/**
 * Org escolhida para UMA aba, sem mexer na org guardada do navegador.
 *
 * A org guardada (`current_org_id` no localStorage) é compartilhada por todas as abas: trocar a
 * org numa aba muda a das outras na próxima carga. Para abrir um registro de outra org numa aba
 * nova sem esse efeito, o link leva `?org=<id>`. Na carga, o id vai para o sessionStorage (que é
 * da aba e sobrevive ao F5) e o parâmetro sai da URL. A resolução da org usa esse id antes do
 * guardado e, quando ele vale, não grava nada no localStorage.
 *
 * Só nas rotas de `ROTAS_COM_ORG_DA_ABA`: `?org=` já tem outro sentido em `/relatorios` (filtro do
 * portal) e na ficha do contrato (trava contra laço da troca de org), e capturá-lo lá trocaria a
 * org da aba sem ninguém pedir.
 *
 * `switchOrganization` limpa o sessionStorage, então uma troca explícita apaga esta escolha.
 */

export const CHAVE_ORG_DA_ABA = 'current_org_id_aba';
export const PARAMETRO_ORG_DA_ABA = 'org';
export const ROTAS_COM_ORG_DA_ABA = ['/deals/'];

/** Lê `?org=` da URL atual (rotas permitidas), guarda na aba e tira o parâmetro da URL. */
export function capturarOrgDaUrl(): void {
  try {
    const url = new URL(window.location.href);
    if (!ROTAS_COM_ORG_DA_ABA.some((r) => url.pathname.startsWith(r))) return;
    if (!url.searchParams.has(PARAMETRO_ORG_DA_ABA)) return;
    const orgId = url.searchParams.get(PARAMETRO_ORG_DA_ABA)?.trim();
    if (orgId) sessionStorage.setItem(CHAVE_ORG_DA_ABA, orgId);
    url.searchParams.delete(PARAMETRO_ORG_DA_ABA);
    // Mantém o `history.state` do React Router (guarda o índice da navegação).
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  } catch {
    // Sem sessionStorage (modo privado restrito) a aba segue a org guardada, como antes.
  }
}

export function lerOrgDaAba(): string | null {
  try {
    return sessionStorage.getItem(CHAVE_ORG_DA_ABA) || null;
  } catch {
    return null;
  }
}

export function descartarOrgDaAba(): void {
  try {
    sessionStorage.removeItem(CHAVE_ORG_DA_ABA);
  } catch {
    // nada a fazer
  }
}
